import { Link } from "react-router-dom";
import { faqs } from "@/mocks/gossip";
import Breadcrumb from "@/components/base/Breadcrumb";
import Seo from "@/components/feature/Seo";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://kanliaochigua.example/" },
      { "@type": "ListItem", position: 2, name: "常见问题", item: "https://kanliaochigua.example/faq" },
    ],
  },
];

export default function Faq() {
  return (
    <>
      <Seo
        title="常见问题 | 内容来源、更新频率与投稿说明 - 看料吃瓜社"
        description="看料吃瓜社常见问题汇总：内容来源、更新频率、线索投稿方式、来源标注规则、是否免费浏览以及更正反馈流程，一次说明清楚。"
        keywords="看料吃瓜常见问题,看料吃瓜投稿,内容来源,更新频率,更正反馈"
        path="/faq"
        jsonLd={jsonLd}
      />

      <div className="w-full bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-6 py-8 md:py-12">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
          <h1 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
            关于内容来源、更新频率、投稿方式与更正流程，我们在这里一次说清楚。如果仍没有解决你的疑问，欢迎直接联系我们。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-8 space-y-5">
            {faqs.map((item, index) => (
              <article
                key={item.q}
                className="p-5 md:p-6 bg-background-50 border border-background-200 rounded-lg"
              >
                <h2 className="font-heading text-base md:text-lg font-semibold text-foreground-950 flex items-start gap-3">
                  <span className="font-label text-xs text-accent-700 bg-accent-100 rounded-md px-2 py-1 shrink-0 mt-0.5">
                    Q{index + 1}
                  </span>
                  {item.q}
                </h2>
                <p className="mt-3 pl-0 md:pl-12 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </article>
            ))}
          </div>

          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 space-y-6">
              <div className="p-6 bg-secondary-950 rounded-lg">
                <span className="w-11 h-11 rounded-lg bg-accent-500 text-foreground-950 flex items-center justify-center text-xl mb-4">
                  <i className="ri-question-answer-line"></i>
                </span>
                <h2 className="font-heading text-lg font-bold text-background-50">还有别的问题？</h2>
                <p className="mt-2 text-sm text-background-300/90 leading-relaxed">
                  线索投稿、内容更正与合作咨询，都可以直接通过联系表单提交，我们通常会在两个工作日内回复。
                </p>
                <Link
                  to="/contact"
                  className="mt-5 inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-label font-medium rounded-md bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  前往联系表单
                </Link>
              </div>

              <div className="p-6 bg-background-100 border border-background-200 rounded-lg">
                <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3">
                  你可能还想看
                </h2>
                <ul className="space-y-2.5">
                  <li>
                    <Link to="/about" className="text-sm font-label text-foreground-600 hover:text-primary-700 transition-colors inline-flex items-center gap-2">
                      <i className="ri-arrow-right-s-line text-primary-500"></i>
                      关于我们与内容原则
                    </Link>
                  </li>
                  <li>
                    <Link to="/topics" className="text-sm font-label text-foreground-600 hover:text-primary-700 transition-colors inline-flex items-center gap-2">
                      <i className="ri-arrow-right-s-line text-primary-500"></i>
                      六条常驻内容线
                    </Link>
                  </li>
                  <li>
                    <Link to="/hot" className="text-sm font-label text-foreground-600 hover:text-primary-700 transition-colors inline-flex items-center gap-2">
                      <i className="ri-arrow-right-s-line text-primary-500"></i>
                      猛料总汇列表
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}